import React from 'react';
import ReactDOM from 'react-dom/client';
import './tailwind.css';
import './index.css';
import App from './App.tsx';
import reportWebVitals from './reportWebVitals';

// Wrap ResizeObserver to defer callbacks — prevents "loop completed" error from PrimeReact dialogs
const _NativeResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _NativeResizeObserver {
  constructor(callback: ResizeObserverCallback) {
    super((entries: ResizeObserverEntry[], observer: ResizeObserver) => {
      requestAnimationFrame(() => callback(entries, observer));
    });
  }
};

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
